module.exports = __webpack_public_path__ + "static/media/team10.57f1fee2.jpeg";